import { render } from "./ModalBusinessRequestProcess.vue?vue&type=template&id=1f326077"
import script from "./ModalBusinessRequestProcess.vue?vue&type=script&lang=js"
export * from "./ModalBusinessRequestProcess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__